import { Button } from 'antd';
import React, { useState } from 'react';
import { FixedMobileMenu } from './FixedMobileMenu';
import { DefaultMenuDrawer } from './MenuDrawer';
import SBMenuIcon from '../../../../assets/images/SwimB_125x125.png';
import hamburger from '../../../../assets/images/hamburgerMenu.svg';
import { useSelector } from 'react-redux';
import CatchReport from '../CatchReport';
import ApCrossing from '../ApCrossing';
import { useAnglerSession } from './useAnglerSession';

function HeaderMenu({
  isLoggedInState,
  loadingState,
  triggerRedirect,
  usesFixedMobileView = false,
}) {
  const [drawerMenuOpen, setDrawerMenuOpen] = useState(false);
  const [, setDrawerCatchReportOpen] = useState(false);
  const { isLoggedIn, loading, handleLogOut } = useAnglerSession(
    isLoggedInState,
    loadingState
  );
  const { showCatchReportDrawer } = useSelector((state) => state.Menu);

  return (
    <>
      <div id='header-menu-right-md'>
        <Button
          className={
            'sb-box-shadow ' &&
            (usesFixedMobileView ? 'header-menu-right-md ' : '')
          }
          type='primary'
          id='header-menu-right'
          onClick={() => setDrawerMenuOpen(true)}
        >
          <img alt='Swimbooker logo' id='menu-open-icon' src={SBMenuIcon} />
          <img alt='hamburger' src={hamburger} />
        </Button>
      </div>

      <DefaultMenuDrawer
        isOpen={drawerMenuOpen}
        setIsOpen={setDrawerMenuOpen}
        isCatchReportOpen={showCatchReportDrawer}
        setIsCatchReportOpen={setDrawerCatchReportOpen}
        loading={loading}
        isLoggedIn={isLoggedIn}
        handleLogOut={handleLogOut}
      />
      <CatchReport isOpen={showCatchReportDrawer} />
      <ApCrossing />
      {usesFixedMobileView && (
        <FixedMobileMenu
          loading={loading}
          isLoggedIn={isLoggedIn}
          handleLogOut={handleLogOut}
        />
      )}
    </>
  );
}

export default HeaderMenu;
